import { useState } from "react";
import { Container, Col } from "react-bootstrap";
import { CupHot } from "react-bootstrap-icons";
import SectionHeading from "../ui/SectionHeading";
import "../style/Menu.css";

const CATEGORIES = [
  {
    label: "Tiffin",
    items: [
      {
        name: "Soft Idli",
        image: "images/dishes/idli.jpg",
        text: "Steamed pillow-soft idlis, served with sambar and chutney.",
      },
      {
        name: "Idli-Vada Combo",
        image: "images/idlivadaa-min.png",
        text: "Idli and crisp-edged vada together, the camp's classic plate.",
      },
    ],
  },
  {
    label: "Dosas",
    items: [
      {
        name: "Masala Dosa",
        image: "images/dishes/masaladosa.jpg",
        text: "Thin, golden and crisp, folded over a spiced potato filling.",
      },
      {
        name: "Ragi Dosa",
        image: "images/dishes/ragidosa.jpg",
        text: "A finger-millet dosa with a nutty bite and real nutrition.",
      },
    ],
  },
  {
    label: "Beverages",
    items: [
      {
        name: "Filter Coffee",
        image: "images/dishes/filtercoffee.jpg",
        text: "Strong, frothy decoction coffee, served the traditional way.",
      },
      {
        name: "Tea",
        text: "Hot, milky masala chai, brewed fresh through the morning.",
      },
    ],
  },
];

function Menu() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = CATEGORIES[activeIndex];

  return (
    <section className="section-pad camp-menu">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="On the Tawa"
          title="What We're Known For"
          subtitle="A short menu, made properly. Pick a category to see what's cooking."
        />

        <div className="camp-menu__tabs" role="tablist" aria-label="Menu categories">
          {CATEGORIES.map((cat, i) => (
            <button
              key={cat.label}
              type="button"
              role="tab"
              aria-selected={i === activeIndex}
              className={`camp-menu__tab ${i === activeIndex ? "is-active" : ""}`}
              onClick={() => setActiveIndex(i)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        <div className="row g-4 camp-menu__grid" key={active.label}>
          {active.items.map((item, i) => (
            <Col sm={6} key={item.name}>
              <div
                className="camp-menu__card card-surface"
                style={{ animationDelay: `${i * 90}ms` }}
              >
                {item.image ? (
                  <img src={item.image} alt={item.name} className="camp-menu__img" />
                ) : (
                  <div className="camp-menu__img camp-menu__img--placeholder">
                    <CupHot size={32} />
                  </div>
                )}
                <div className="camp-menu__body">
                  <h3>{item.name}</h3>
                  <p>{item.text}</p>
                </div>
              </div>
            </Col>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Menu;
